import { render, staticRenderFns } from "./PracticePage.vue?vue&type=template&id=0ff44255&scoped=true&"
import script from "./PracticePage.vue?vue&type=script&lang=js&"
export * from "./PracticePage.vue?vue&type=script&lang=js&"
import style0 from "./PracticePage.vue?vue&type=style&index=0&id=0ff44255&scoped=true&lang=css&"
import style1 from "./PracticePage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff44255",
  null
  
)

export default component.exports